import EndGameMessage from './end-game';

export default EndGameMessage;
